import React from 'react';
import PropTypes from 'prop-types';

const PdpRespTradeNegotiationModal = React.lazy(() =>
    import(/* webpackChunkName: "TradeNegotiationModalLoaderChunk" */ './PdpRespTradeNegotiationModal')
);

export function PdpRespTradeNegotiationModalLoader({ environment, currency, itemId }) {
    return (
        <React.Suspense fallback={null}>
            <PdpRespTradeNegotiationModal
                environment={environment}
                currency={currency}
                itemId={itemId}
            />
        </React.Suspense>
    );
}

PdpRespTradeNegotiationModalLoader.propTypes = {
    environment: PropTypes.object,
    currency: PropTypes.string,
    itemId: PropTypes.string,
};
